@if (selectAuth$|async; as selectAuth) {
<div>
  <!-- when not authentified-->
  @if (!selectAuth.authentified) {
  <div>
    @if (!selectAuth.loadingGroup.isStarted()) {
    <button mat-raised-button color="primary" id="authentication-form-connection"
      data-tfa="authentication-form-connection" i18n="Form|The connection button@@AUTH-CONNECT"
      (click)="connectDeconnect()">
      <mat-icon data-tfa="btn-login-icon" aria-hidden="true">login</mat-icon>
      <span data-tfa="btn-login-text">Se connecter</span>
    </button>
    }
    @if (selectAuth.loadingGroup.isStarted()) {
    <mat-progress-spinner color="accent" mode="indeterminate" diameter="40"></mat-progress-spinner>
    }
  </div>
  }
  <!-- when authentified-->
  @if (selectAuth.authentified) {
  <div class="authentication-form-container">
    @if (selectAuth.user.profile) {
    <button mat-mini-fab color="secondary" [matMenuTriggerFor]="menu" data-tfa="profile" aria-label="profil">
      <mat-icon class="mat-icon" aria-hidden="true" data-tfa="profile-picture">account_circle</mat-icon>
    </button>
    <span class="mat-caption identifiant-user">{{ selectAuth.user.profile.preferred_username ||
      selectAuth.user.profile.sub }}</span>
    <mat-menu #menu="matMenu">
      <button mat-menu-item color="primary" id="authentication-form-deconnection"
        data-tfa="authentication-form-deconnection" i18n="Form|The connection button@@AUTH-DECONNECT"
        (click)="connectDeconnect()">Se déconnecter
      </button>
    </mat-menu>
    }
  </div>
  }
</div>
}